var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3345 9.66374V18.002C18.3345 19.6 17.0551 20.8955 15.477 20.8955H9.00001C7.42185 20.8955 6.1425 19.6 6.1425 18.002V9.66374M10.6153 13.0387V17.3668M13.8605 13.0387V17.3668M15.082 4.45882L15.8675 6.17222H18.4013C19.1804 6.17222 19.812 6.80378 19.812 7.58286V8.62753C19.812 9.1602 19.3801 9.59201 18.8475 9.59201H5.62854C5.09587 9.59201 4.66406 9.1602 4.66406 8.62753V7.58286C4.66406 6.80378 5.29563 6.17222 6.07472 6.17222H8.60856L9.39403 4.45882C9.62971 3.94464 10.1435 3.61499 10.7091 3.61499H13.7669C14.3326 3.61499 14.8463 3.94464 15.082 4.45882Z",
    stroke: "#FF5F58",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fe24ffd6ccfc2b47daa3f6db3fdf1245.svg";
export { ForwardRef as ReactComponent };